import React from "react";
import ReactDOM from "react-dom/client";
import "../../index.css";
// codex.md v4: Tailwind + Tremor overrides. Imported AFTER index.css so
// our dark-theme overrides win the cascade. Tailwind content config
// scopes utility generation to the chart folders only — legacy
// components keep their custom CSS untouched.
import "../../styles/tremor.css";
import AppRouter from "../router/AppRouter";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <AppRouter />
  </React.StrictMode>
);
